<template>
  <div class="field-notice-comp">
    <div class="flex-row valign-center">
      <span>{{ title }}</span>
      <el-input-number
        class="days-input"
        v-model="valueInfo.days"
        controls-position="right"
        :min="1"
        :max="365"
        :disabled="disabled"
      ></el-input-number>
      <span>天提醒</span>
    </div>
    <div class="choose-area flex-valign">
      <div class="flex-valign message-item-area">
        <el-checkbox
          label="短信通知"
          v-model="valueInfo.sms.checked"
          :disabled="disabled"
        ></el-checkbox>
        <div v-if="valueInfo.sms.checked">
          <el-select
            class="mt10 full-width"
            v-model="valueInfo.sms.messageModel"
            placeholder="请选择消息模板"
            :disabled="disabled"
            @change="changeModel($event, 'sms')"
          >
            <el-option
              v-for="(item, i) in smsMessages"
              :key="i"
              :label="item.noticeTemplateName"
              :value="item.noticeTemplateCode"
            ></el-option>
          </el-select>
          <el-input
            class="mt10"
            type="textarea"
            :rows="3"
            placeholder="消息模板内容"
            readonly
            resize="none"
            :disabled="disabled"
            v-model="valueInfo.sms.messageContent"
          >
          </el-input>
        </div>
      </div>
      <div class="flex-valign message-item-area mt10">
        <el-checkbox
          label="消息通知"
          :disabled="disabled"
          v-model="valueInfo.appMsg.checked"
        ></el-checkbox>
        <div v-if="valueInfo.appMsg.checked">
          <el-select
            class="mt10 full-width"
            v-model="valueInfo.appMsg.messageModel"
            placeholder="请选择消息模板"
            :disabled="disabled"
            @change="changeModel($event, 'appMsg')"
          >
            <el-option
              v-for="(item, i) in appMessages"
              :key="i"
              :label="item.noticeTemplateName"
              :value="item.noticeTemplateCode"
            ></el-option>
          </el-select>
          <el-input
            class="mt10"
            type="textarea"
            :rows="3"
            placeholder="消息模板内容"
            readonly
            resize="none"
            :disabled="disabled"
            v-model="valueInfo.appMsg.messageContent"
          >
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fieldNotice",
  model: {
    prop: "valueInfo",
    event: "handleReturn",
  },
  props: {
    title: {
      type: String,
      default: () => {
        return "超期前";
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    valueInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    modelContent: {
      type: Object,
      default: () => {
        return {};
      },
    },
    smsMessages: {
      type: Array,
      default: () => {
        return [];
      },
    },
    appMessages: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    valueInfo(newVal) {
      this.$emit("handleReturn", this.valueInfo);
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    changeModel(value, type) {
      this.valueInfo[type].messageContent = this.modelContent[value];
    },
  },
};
</script>

<style lang="scss">
.field-notice-comp {
  .days-input {
    margin: 0 10px;
  }
  .choose-area {
    margin-top: 10px;
  }
}
</style>